import { css } from "@compiled/react";
import { useIntl } from "react-intl";

export const NoCreditCardRequired = () => {
    const { formatMessage } = useIntl();
    return (
        <p css={noCreditCardRequiredCss}>
            {formatMessage({
                id: "WacSignupForm.FirstImpressions.noCreditCardRequiredFooter",
                defaultMessage: "No credit card required"
            })}
        </p>
    );
};

const noCreditCardRequiredCss = css({
    fontSize: 14,
    fontWeight: 500,
    letterSpacing: 1,
    margin: "32px 0",
    textAlign: "center",
    textTransform: "uppercase"
});
